// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA0aroAAkBgSdfzevtalPLLYjpqOiRsYzA",
    authDomain: "alltsk-eu.firebaseapp.com",
    databaseURL: "https://alltsk-eu.firebaseio.com",
    projectId: "alltsk-eu",
    storageBucket: "alltsk-eu.appspot.com",
    messagingSenderId: "934876723654",
    appId: "1:934876723654:web:0f0e4a0ef0276aca"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
